import { render, staticRenderFns } from "./PackMarkDetailList.vue?vue&type=template&id=49740d08&"
import script from "./PackMarkDetailList.vue?vue&type=script&lang=js&"
export * from "./PackMarkDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports